import * as React from "react"
import styled from "styled-components"
import H0 from "../atoms/typography/H0"
import { theme } from "../theme"
import { HorizontalSpacer } from "../atoms/spacers"
import H1 from "../atoms/typography/H1"
import { Container, Row } from "react-grid-system"
import LargeButton from "../atoms/buttons/LargeButton"
import { Link } from "react-router-dom"
import { MediaQuery } from "../../utils/design-helpers"

const BackgroundImage = styled.img`
  width: 100vw;
  height: 100vh;
  object-fit: cover;
`

const TextContainer = styled.div`
  position: absolute;
  left: 0;
  top: 30%;
  padding: 1rem;
  width: 100%;

  ${MediaQuery.XS} {
    top: 15%;
  }
`

const MissingPage: React.FC = () => {
  return (
    <div>
      <BackgroundImage
        src="https://images.ctfassets.net/kzqg847wz5jr/3oHuCeP8fQisALYtEsaaCD/0ea02dbb49f2edcc193b2a45d4026b0b/404.webp"
        alt="Satcube 404 page missing image"
      />
      <TextContainer>
        <Container>
          <H0 color={theme.colors.white} textAlign="center">
            Our apologies
          </H0>
          <HorizontalSpacer spacing={2} />
          <H1 color={theme.colors.white} textAlign="center">
            The page you requested does not exist (404 error)
          </H1>
          <HorizontalSpacer spacing={2} />
          <Row justify="center">
            <Link to="/">
              <LargeButton title="Back to Home page" />
            </Link>
          </Row>
        </Container>
      </TextContainer>
    </div>
  )
}

export default MissingPage
